const state = {
    // 是否更新用户订单列表
    isUpdateOrderList: false,
    // 代步车门店列表
    addressList: [],
    // 用户权限
    scooterVip: {}
}
export default state